import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Navbar from './components/Navbar';
import Header from './components/Header';
import About from './components/About';
import Trainers from './components/Trainers';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Exercises from './components/Exercises';     // ← Yeh abhi banana hai (API wala)
import Footer from './components/Footer';
// import BottomNav from './components/BottomNav';
// import FloatingContact from './components/FloatingContact';
import WhatsAppIcon from './components/WhatsAppIcon';

function App() {
  return (
    <Router>
      <div className="bg-background-light dark:bg-background-dark text-slate-900 dark:text-white pb-24 min-h-screen">
        
        <Navbar />
        
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <About />
              <Trainers />
              <Gallery />
              <Contact />
            </>
          } />
          
          <Route path="/exercises" element={<Exercises />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        <Footer />
        {/* <BottomNav /> */}
        {/* <FloatingContact /> */}
        <WhatsAppIcon />
        
      </div>
    </Router>
  );
}

export default App;